import { useQuery } from '@apollo/client';
import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PagePaper from './layout/PagePaper';
import Note from './layout/Note';
import PageContainer from './layout/PageContainer';
import { GET_USERS } from '../gql/users';
import Loading from './layout/Loading';
import UsersItem from './UsersItem';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

const Users = () => {
  const classes = useStyles();
  const { loading, error, data } = useQuery(GET_USERS);

  if (loading) return <Loading />;
  if (error) {
    console.log(error);
  }

  return (
    <>
      <PageContainer title="Users">
        <Note>Summary and mainenance of admin users</Note>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <PagePaper>
              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  component={Link}
                  to="/users/add"
                  className={classes.button}
                  startIcon={<PersonAddIcon />}
                >
                  add user
                </Button>
              </div>
              <List>
                {data.users.map((user) => (
                  <UsersItem user={user} key={user.id} />
                ))}
              </List>
            </PagePaper>
          </Grid>
        </Grid>
      </PageContainer>
    </>
  );
};

export default Users;
